import React, { SVGProps } from 'react';
import { Colors } from '../../../../styles/colors.ts';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
}

export const PilNed: React.FC<SvgProps> = ({ pathFill = Colors.borders.primary, ...props }) => (
	<svg
		width='16'
		height='10'
		viewBox='0 0 16 10'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<g id='Chevron set/Down/16px'>
			<path
				id='chevron'
				d='M7.37821 9.73477L0.257567 2.40132C-0.0858556 2.04764 -0.0858555 1.47423 0.257567 1.12058L1.08808 0.265254C1.43091 -0.0878268 1.98655 -0.0885059 2.33019 0.263744L8.00002 6.07563L13.6698 0.263745C14.0134 -0.0885053 14.5691 -0.0878262 14.9119 0.265254L15.7424 1.12058C16.0859 1.47426 16.0859 2.04767 15.7424 2.40132L8.62179 9.73473C8.27841 10.0884 7.72163 10.0884 7.37821 9.73477Z'
				fill={pathFill}
			/>
		</g>
	</svg>
);
